import { useRef } from "react";
import { Text } from "@chakra-ui/react";
import { AlertDialog } from "pixelize-design-library";

export type ConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  isConfirmLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const ConfirmDialog = ({
  isOpen,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  isConfirmLoading,
  onConfirm,
  onClose,
}: ConfirmDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      title={title}
      content={<Text>{description}</Text>}
      confirmButtonText={confirmLabel}
      cancelButtonText={cancelLabel}
      isConfirmLoading={isConfirmLoading}
      onConfirm={onConfirm}
      colorScheme={destructive ? "error" : "primary"}
    />
  );
};
